// src/button/src/base.tsx
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var BaseButton = forwardRef(
  ({
    as: Component = "button",
    children,
    onClick,
    disabled,
    ...rest
  }, forwardedRef) => {
    const handlePreventDefault = React.useCallback(
      (event) => {
        event.preventDefault();
      },
      []
    );
    const handleClick = (event) => {
      if (Boolean(disabled)) {
        handlePreventDefault(event);
        return;
      }
      onClick?.(event);
    };
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ jsx(Component, { ref: forwardedRef, ...rest, onClick: handleClick, children })
    );
  }
);

export {
  BaseButton
};
